<template>
  <div class="app-container">
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item class="numberSearch" label="">
            <template slot="label">
              <el-select v-model="type1" :placeholder="$t('CenterForSorting.pleaseChoose')">
                <el-option :label="$t('CenterForSorting.scanNumber')" value="scanOrderNumberList" />
                <el-option
                  :label="$t('CenterForSorting.waybillNumber')"
                  value="waybillNumberList"
                />
              </el-select>
            </template>
            <InputTextareaCmp
              ref="inputTextareaRef"
              :max-length="2000"
              :min-rows="2"
              :val="listVal"
              @input="(_, val) => (listVal = val)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.machine')">
            <el-select
              v-model="searchForm.machineCode"
              :placeholder="$t('CenterForSorting.pleaseChoose')"
              clearable
              @change="handleSearch"
            >
              <el-option
                v-for="item in machineList"
                :key="item.machineCode"
                :label="item.machineName + '(' + item.machineCode + ')'"
                :value="item.machineCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.chuteNo')">
            <el-input
              v-model="searchForm.chuteNumber"
              :placeholder="$t('CenterForSorting.pleaseInput')"
              clearable
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.bagNumber')">
            <el-input
              v-model="searchForm.bagNumber"
              :placeholder="$t('CenterForSorting.pleaseInput')"
              clearable
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('CenterForSorting.uploadStatus')">
            <el-select
              v-model="searchForm.status"
              :placeholder="$t('CenterForSorting.pleaseChoose')"
              clearable
              @change="handleSearch"
            >
              <el-option :label="$t('CenterForSorting.all')" :value="null" />
              <el-option :label="$t('CenterForSorting.statusUploaded')" :value="0" />
              <el-option :label="$t('CenterForSorting.statusBagged')" :value="1" />
              <el-option :label="$t('CenterForSorting.statusCleaning')" :value="2" />
              <el-option :label="$t('CenterForSorting.statusRemovedFromBag')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('CenterForSorting.timeRange')">
            <el-date-picker
              v-model="searchForm.createTime"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('CenterForSorting.endTime')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('CenterForSorting.startTime')"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @focus="pickDate = null"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 28px">
            <el-button
              icon="el-icon-search" size="mini" type="primary"
              @click="handleSearch"
            >{{ $t('CenterForSorting.search') }}
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetSearch">{{ $t('CenterForSorting.reset') }}
            </el-button>
            <!--导出-->
            <el-button size="small" type="primary" @click="allExportOrder">{{ $t('collectionCenter.export') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-card>
      <div style="margin-bottom: 10px">
        <el-button
          v-permit:remove="'btn:sorting:uploadRecord:doBagging'"
          icon="el-icon-box"
          size="mini"
          type="success"
          @click="handleBaggingClick"
        >{{ $t('CenterForSorting.doBagging') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:sorting:uploadRecord:clearData'"
          icon="el-icon-delete"
          size="mini"
          type="warning"
          @click="handleCleanClick"
        >{{ $t('CenterForSorting.clearData') }}
        </el-button>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.ind')"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          :label="$t('CenterForSorting.scanNumber')"
          align="center"
          min-width="160"
          prop="scanOrderNumber"
        />
        <el-table-column
          :label="$t('CenterForSorting.waybillNumber')"
          align="center"
          min-width="160"
          prop="waybillNumber"
        />
        <el-table-column :label="$t('CenterForSorting.scanGrid')" align="center" min-width="120">
          <template slot-scope="{ row }">
            <template v-if="row.scanGrid">
              <el-tag
                v-for="(grid, index) in String(row.scanGrid).split(',')"
                :key="index"
                style="margin-right: 4px; margin-bottom: 4px"
              >
                {{ grid }}
              </el-tag>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('CenterForSorting.chuteNo')" align="center" width="100">
          <template slot-scope="{ row }">
            <template v-if="row.chuteNumber">
              <el-tag
                v-for="(chute, index) in String(row.chuteNumber).split(',')"
                :key="index"
                style="margin-right: 4px; margin-bottom: 4px"
              >
                {{ chute }}
              </el-tag>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.machineCode')"
          align="center"
          prop="machineCode"
          width="120"
        />
        <el-table-column :label="$t('CenterForSorting.supplyTable')" align="center" width="180">
          <template slot-scope="{ row }">
            <span>{{ getSupplyTableLabel(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.personAccount')"
          align="center"
          prop="personAccount"
          width="180"
        />
        <el-table-column
          :label="$t('CenterForSorting.supplyTime')"
          align="center"
          prop="supplyTime"
          width="160"
        />
        <el-table-column
          :label="$t('CenterForSorting.matchRule')"
          align="center"
          min-width="120"
          prop="matchedRuleName"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-button v-if="row.matchedRuleName" type="text" @click="handleViewConditions(row)">
              {{ row.matchedRuleName }}
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.bagNumber')"
          align="center"
          prop="bagNumber"
          width="150"
        />
        <el-table-column
          :label="$t('CenterForSorting.baggingType')"
          align="center"
          prop="baggingType"
          width="150"
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.baggingType === 1" type="success">{{ $t('CenterForSorting.normalBagging') }}
            </el-tag>
            <el-tag v-else-if="row.baggingType === 2" type="warning">{{ $t('CenterForSorting.fallbackBagging') }}
            </el-tag>
            <el-tag v-else-if="row.baggingType === 3" type="danger">{{ $t('CenterForSorting.abnormalBagging') }}
            </el-tag>
            <span v-else>{{ row.baggingType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.repeatBaggingCount')"
          align="center"
          prop="repeatBaggingCount"
          width="120"
        />
        <el-table-column
          :label="$t('CenterForSorting.description')"
          align="center"
          min-width="150"
          prop="description"
          show-overflow-tooltip
        />
        <el-table-column
          :label="$t('CenterForSorting.weightWithUnit')"
          align="center"
          prop="weight"
          width="100"
        />
        <el-table-column :label="$t('CenterForSorting.uploadStatus')" align="center" width="100">
          <template slot-scope="{ row }">
            <el-tag
              :type="
                row.status === 1
                  ? 'success'
                  : row.status === 2
                    ? 'warning'
                    : row.status === 3
                      ? 'danger'
                      : 'primary'
              "
            >
              {{
                row.status === 1
                  ? $t('CenterForSorting.statusBagged')
                  : row.status === 2
                    ? $t('CenterForSorting.statusCleaning')
                    : row.status === 3
                      ? $t('CenterForSorting.statusRemovedFromBag')
                      : $t('CenterForSorting.statusUploaded')
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.createTime')"
          align="center"
          prop="createTime"
          width="160"
        />
        <el-table-column
          :label="$t('CenterForSorting.operation')"
          align="center"
          fixed="right"
          width="120"
        >
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status === 2 || row.status === 3"
              icon="el-icon-remove-outline"
              size="mini"
              type="text"
              @click="handleRemoveFromBag(row)"
            >{{ $t('CenterForSorting.removeFromBag') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="listQuery.pageNumber"
          :page-size.sync="listQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="fetchData"
          @size-change="fetchData"
        />
      </div>
    </el-card>

    <!-- 封袋确认对话框 -->
    <el-dialog
      :title="$t('CenterForSorting.baggingConfirm')"
      :visible.sync="baggingDialogVisible"
      width="500px"
    >
      <el-form ref="baggingForm" :model="baggingTemp" label-position="top">
        <el-form-item
          :label="$t('CenterForSorting.machine')"
          :rules="[
            { required: true, message: $t('CenterForSorting.pleaseChoose'), trigger: 'change' }
          ]"
          prop="machineCode"
        >
          <el-select
            v-model="baggingTemp.machineCode"
            :placeholder="$t('CenterForSorting.pleaseChoose')"
            filterable
            style="width: 100%"
            @change="handleBaggingMachineChange"
          >
            <el-option
              v-for="item in machineList"
              :key="item.machineCode"
              :label="item.machineName + '(' + item.machineCode + ')'"
              :value="item.machineCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('CenterForSorting.chuteNo')"
          :rules="[
            { required: true, message: $t('CenterForSorting.pleaseChoose'), trigger: 'change' }
          ]"
          prop="chuteNumber"
        >
          <el-select
            v-model="baggingTemp.chuteNumber"
            :placeholder="$t('CenterForSorting.pleaseChoose')"
            filterable
            style="width: 100%"
            @change="handleBaggingChuteChange"
          >
            <el-option
              v-for="opt in chuteOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('CenterForSorting.bagNumber')"
          :rules="[
            { required: true, message: $t('CenterForSorting.inputBagNumber'), trigger: 'blur' }
          ]"
          prop="bagNumber"
        >
          <el-input
            v-model="baggingTemp.bagNumber"
            :placeholder="$t('CenterForSorting.inputBagNumber')"
          />
        </el-form-item>

        <div v-if="previewList.length > 0" class="preview-area">
          <el-divider content-position="left">{{ $t('CenterForSorting.previewPackage') }}
          </el-divider>
          <el-table
            :data="pagedPreviewList" border height="200"
            size="mini"
          >
            <el-table-column :label="$t('CenterForSorting.scanNumber')" prop="scanOrderNumber">
              <template slot-scope="{ row }">
                <span>{{ row.scanOrderNumber }}</span>
                <el-tooltip
                  v-if="row.baggingType === 2 || row.baggingType === 3"
                  :content="
                    row.baggingType === 2
                      ? $t('CenterForSorting.fallbackBagging')
                      : $t('CenterForSorting.abnormalBagging')
                  "
                  placement="top"
                >
                  <i class="el-icon-warning" style="color: #e6a23c; margin-left: 5px" />
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('CenterForSorting.waybillNumber')" prop="waybillNumber" />
          </el-table>
          <el-pagination
            v-if="previewList.length > previewPageSize"
            :current-page.sync="previewPage"
            :page-size="previewPageSize"
            :total="previewList.length"
            layout="prev, pager, next"
            small
            style="text-align: right; margin-top: 5px"
          />
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="baggingDialogVisible = false">{{ $t('CenterForSorting.cancel') }}
        </el-button>
        <el-button :loading="dialogBtnLoading" type="primary" @click="confirmBagging">
          {{ $t('CenterForSorting.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 清理数据对话框 -->
    <el-dialog
      :title="$t('CenterForSorting.clearData')"
      :visible.sync="cleanDialogVisible"
      width="500px"
    >
      <el-form ref="cleanForm" :model="cleanTemp" label-position="top">
        <el-form-item
          :label="$t('CenterForSorting.machine')"
          :rules="[
            { required: true, message: $t('CenterForSorting.pleaseChoose'), trigger: 'change' }
          ]"
          prop="machineCode"
        >
          <el-select
            v-model="cleanTemp.machineCode"
            :placeholder="$t('CenterForSorting.pleaseChoose')"
            filterable
            style="width: 100%"
            @change="handleCleanMachineChange"
          >
            <el-option
              v-for="item in machineList"
              :key="item.machineCode"
              :label="item.machineName + '(' + item.machineCode + ')'"
              :value="item.machineCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('CenterForSorting.chuteNo')"
          :rules="[
            { required: true, message: $t('CenterForSorting.pleaseChoose'), trigger: 'change' }
          ]"
          prop="chuteNumber"
        >
          <el-select
            v-model="cleanTemp.chuteNumber"
            :placeholder="$t('CenterForSorting.pleaseChoose')"
            filterable
            style="width: 100%"
            @change="handleCleanChuteChange"
          >
            <el-option
              v-for="opt in chuteOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </el-form-item>

        <div v-if="bagCountInfo" class="info-area" style="margin-top: 20px">
          <el-alert
            :closable="false"
            :title="`${$t('CenterForSorting.bagCount')}: ${bagCountInfo.bagCount}`"
            show-icon
            type="info"
          />
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cleanDialogVisible = false">{{ $t('CenterForSorting.cancel') }}
        </el-button>
        <el-button
          :disabled="!cleanTemp.chuteId"
          :loading="dialogBtnLoading"
          type="primary"
          @click="confirmClean"
        >
          {{ $t('CenterForSorting.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 查看条件对话框 -->
    <rule-condition-detail
      :condition-configs="conditionConfigs"
      :rule-id="currentRuleId"
      :visible.sync="viewConditionsVisible"
    />
  </div>
</template>

<script>
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import {
  getCountByChute,
  getListByChute,
  getUploadRecordPage,
  removeFromBag,
  uploadChuteData
} from '@/api/sorting/uploadRecord';
import { clearChuteData, getAllMachineList } from '@/api/sorting/machine';
import { getConditionConfigList } from '@/api/sorting/rule';
import RuleConditionDetail from './components/RuleConditionDetail';
import { goResourceTaskList } from '@/utils/goExportList';
import { uploadRecordExportAll } from '@/api/sorting/record';

export default {
  name: 'UploadRecord',
  components: {
    InputTextareaCmp,
    RuleConditionDetail
  },
  data() {
    return {
      type1: 'scanOrderNumberList',
      listVal: '',
      tableData: [],
      total: 0,
      listLoading: true,
      listQuery: {
        pageNumber: 1,
        pageSize: 10
      },
      searchForm: {
        machineCode: '',
        chuteNumber: '',
        bagNumber: '',
        status: null,
        createTime: this.getDefaultTimeRange()
      },
      machineList: [],

      // Bagging Dialog
      baggingDialogVisible: false,
      baggingTemp: {
        machineCode: '',
        chuteNumber: '',
        bagNumber: ''
      },

      // Clean Dialog
      cleanDialogVisible: false,
      cleanTemp: {
        machineCode: '',
        chuteNumber: '',
        chuteId: null
      },
      bagCountInfo: null,
      chuteOptions: [],
      previewList: [],
      previewPage: 1,
      previewPageSize: 10,
      dialogBtnLoading: false,
      conditionConfigs: [],
      viewConditionsVisible: false,
      currentRuleId: null,
      pickDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = minDate;
          if (maxDate) {
            this.pickDate = null;
          }
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const oneDay = 24 * 3600 * 1000;
            const minTime = this.pickDate.getTime() - 6 * oneDay;
            const maxTime = this.pickDate.getTime() + 6 * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      }
    };
  },
  computed: {
    pagedPreviewList() {
      const start = (this.previewPage - 1) * this.previewPageSize;
      const end = start + this.previewPageSize;
      return this.previewList.slice(start, end);
    }
  },
  created() {
    this.fetchMachines();
    this.fetchConditionConfigs();
    this.fetchData();
  },
  methods: {
    getDefaultTimeRange() {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setHours(23, 59, 59, 999);

      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const h = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        const s = String(date.getSeconds()).padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
      };

      return [formatDate(start), formatDate(end)];
    },
    async fetchMachines() {
      // 获取设备列表用于下拉选择
      const res = await getAllMachineList();
      this.machineList = res.data || [];
    },
    async fetchConditionConfigs() {
      const res = await getConditionConfigList();
      this.conditionConfigs = res.data || [];
    },
    handleViewConditions(row) {
      // 优先使用 matchedRuleId，如果没有则使用 ruleId
      const ruleId = row.matchedRuleId || row.ruleId;
      if (!ruleId) return;
      this.currentRuleId = ruleId;
      this.viewConditionsVisible = true;
    },
    fetchData() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        this.listLoading = false;
        return;
      }

      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          this.listLoading = false;
          return;
        }
      }

      this.listLoading = true;
      const params = {
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize,
        params: {
          machineCode: this.searchForm.machineCode || undefined,
          chuteNumber: this.searchForm.chuteNumber || undefined,
          bagNumber: this.searchForm.bagNumber || undefined,
          status: this.searchForm.status,
          createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
          createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
        }
      };

      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params.params[this.type1] = inputVal;
      }

      getUploadRecordPage(params)
        .then((response) => {
          this.tableData = response.data.records;
          this.total = response.data.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.fetchData();
    },
    resetSearch() {
      this.type1 = 'scanOrderNumberList';
      this.listVal = '';
      this.searchForm = {
        machineCode: '',
        chuteNumber: '',
        bagNumber: '',
        status: null,
        createTime: this.getDefaultTimeRange()
      };
      this.handleSearch();
    },
    getSupplyTableEnumValue(row) {
      const key = 'tableNumber';
      if (row && row[key] !== undefined && row[key] !== null && row[key] !== '') {
        return this.normalizeSupplyTableEnumValue(row[key]);
      }
      return '';
    },
    normalizeSupplyTableEnumValue(value) {
      const rawValue = String(value).trim();
      if (!rawValue) {
        return '';
      }
      const matched = rawValue.match(/(\d{1,2})$/);
      if (!matched) {
        return rawValue;
      }
      const normalizedNumber = Number(matched[1]);
      if (!Number.isInteger(normalizedNumber) || normalizedNumber < 1 || normalizedNumber > 24) {
        return rawValue;
      }
      return String(normalizedNumber);
    },
    getSupplyTableLabel(row) {
      const enumValue = this.getSupplyTableEnumValue(row);
      if (!enumValue) {
        return '-';
      }
      const machineCode = row && row.machineCode ? String(row.machineCode).trim() : '';
      const i18nKeys = machineCode ? [`CenterForSorting.${machineCode}${enumValue}`] : [enumValue];
      for (let i = 0; i < i18nKeys.length; i++) {
        const key = i18nKeys[i];
        const text = this.$t(key);
        if (text !== key) {
          return text;
        }
      }
      return enumValue;
    },

    // --- 辅助方法：生成格口选项 ---
    generateChuteOptions(machineCode) {
      this.chuteOptions = [];
      const machine = this.machineList.find((m) => m.machineCode === machineCode);
      if (machine && machine.chuteCount) {
        for (let i = 1; i <= machine.chuteCount; i++) {
          const val = String(i).padStart(3, '0');
          this.chuteOptions.push({ value: val, label: val });
        }
      }
    },

    // --- 封袋逻辑 ---
    handleBaggingClick() {
      this.baggingTemp = {
        machineCode: '',
        chuteNumber: '',
        bagNumber: ''
      };
      this.chuteOptions = [];
      this.previewList = [];
      this.previewPage = 1;
      this.baggingDialogVisible = true;
      this.$nextTick(() => {
        this.$refs['baggingForm'] && this.$refs['baggingForm'].clearValidate();
      });
    },
    handleBaggingMachineChange(val) {
      this.baggingTemp.chuteNumber = '';
      this.generateChuteOptions(val);
    },
    async handleBaggingChuteChange() {
      if (!this.baggingTemp.machineCode || !this.baggingTemp.chuteNumber) return;
      // 获取预览数据
      try {
        const res = await getListByChute({
          machineCode: this.baggingTemp.machineCode,
          chuteNumber: this.baggingTemp.chuteNumber
        });
        this.previewList = res.data || [];
        this.previewPage = 1;
      } catch (e) {
        console.error(e);
      }
    },
    confirmBagging() {
      this.$refs['baggingForm'].validate((valid) => {
        if (valid) {
          this.dialogBtnLoading = true;
          const params = {
            chuteCode: `${this.baggingTemp.chuteNumber}-${this.baggingTemp.machineCode}`,
            bagNumber: this.baggingTemp.bagNumber
          };
          uploadChuteData(params)
            .then(() => {
              this.baggingDialogVisible = false;
              this.dialogBtnLoading = false;
              this.$message.success(this.$t('CenterForSorting.baggingSuccess'));
              this.fetchData();
            })
            .catch(() => {
              this.dialogBtnLoading = false;
            });
        }
      });
    },

    // --- 清理逻辑 ---
    handleCleanClick() {
      this.cleanTemp = {
        machineCode: '',
        chuteNumber: '',
        chuteId: null
      };
      this.chuteOptions = [];
      this.bagCountInfo = null;
      this.cleanDialogVisible = true;
      this.$nextTick(() => {
        this.$refs['cleanForm'] && this.$refs['cleanForm'].clearValidate();
      });
    },
    handleCleanMachineChange(val) {
      this.cleanTemp.chuteNumber = '';
      this.bagCountInfo = null;
      this.generateChuteOptions(val);
    },
    async handleCleanChuteChange() {
      this.bagCountInfo = null;
      this.cleanTemp.chuteId = null;
      if (!this.cleanTemp.machineCode || !this.cleanTemp.chuteNumber) return;

      try {
        const res = await getCountByChute({
          machineCode: this.cleanTemp.machineCode,
          chuteNumber: this.cleanTemp.chuteNumber
        });
        // 返回 { id, bagCount }
        this.bagCountInfo = res.data;
        if (this.bagCountInfo && this.bagCountInfo.id) {
          this.cleanTemp.chuteId = this.bagCountInfo.id;
        }
      } catch (e) {
        console.error(e);
      }
    },
    confirmClean() {
      this.$refs['cleanForm'].validate((valid) => {
        if (valid) {
          if (!this.cleanTemp.chuteId) {
            this.$message.warning(this.$t('CenterForSorting.invalidChuteId'));
            return;
          }

          this.$confirm(
            this.$t('CenterForSorting.confirmClearData', { chuteNo: this.cleanTemp.chuteNumber }),
            this.$t('CenterForSorting.tips'),
            {
              confirmButtonText: this.$t('CenterForSorting.sure'),
              cancelButtonText: this.$t('CenterForSorting.cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.dialogBtnLoading = true;
            clearChuteData({ chuteId: this.cleanTemp.chuteId })
              .then(() => {
                this.cleanDialogVisible = false;
                this.dialogBtnLoading = false;
                this.$message.success(this.$t('CenterForSorting.clearSuccess'));
                this.fetchData();
              })
              .catch(() => {
                this.dialogBtnLoading = false;
              });
          });
        }
      });
    },
    // --- 移除出袋 ---
    handleRemoveFromBag(row) {
      this.$confirm(
        this.$t('CenterForSorting.confirmRemoveFromBag'),
        this.$t('CenterForSorting.tips'),
        {
          confirmButtonText: this.$t('CenterForSorting.sure'),
          cancelButtonText: this.$t('CenterForSorting.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          const params = {
            chuteCode: `${row.chuteNumber}-${row.machineCode}`,
            scanNumber: row.scanOrderNumber || row.waybillNumber
          };
          removeFromBag(params).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('CenterForSorting.removeSuccess'));
              this.fetchData();
            }
          });
        })
        .catch(() => {});
    },
    // 导出
    allExportOrder() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        return;
      }
      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          return;
        }
      }
      const params = {
        machineCode: this.searchForm.machineCode || undefined,
        chuteNumber: this.searchForm.chuteNumber || undefined,
        bagNumber: this.searchForm.bagNumber || undefined,
        status: this.searchForm.status,
        createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
        createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
      };
      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params[this.type1] = inputVal;
      }
      uploadRecordExportAll(params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style scoped>
.numberSearch ::v-deep .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
</style>
